import React from "react";
import {
    BrowserRouter,
    Navigate,
    Outlet,
    Route,
    Routes,
    useLocation,
} from "react-router-dom";
import * as Screen from "../screens";
import { SiteLayout } from "../components";
import { useAppSelector } from "../redux-config/hooks";
import { selectUser } from "../redux-config/entities/user";
import { isClinicUser } from "../utils";

export const RouterPage = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<Screen.NotFound />}></Route>
                <Route path="/login" element={<Screen.Login />} />
                <Route path="" element={<Auth />}>
                    <Route
                        path=""
                        element={
                            <SiteLayout>
                                <HomeEntry />
                            </SiteLayout>
                        }
                    ></Route>
                    <Route path="clinic" element={<ClinicOnly />}>
                        <Route
                            path="patients"
                            element={
                                <SiteLayout>
                                    <Screen.ClinicPatientsList />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path="patients/new"
                            element={
                                <SiteLayout>
                                    <Screen.CreateClinicPatient />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path="patients/:id"
                            element={
                                <SiteLayout>
                                    <Screen.ClinicPatientDetails />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path="settings"
                            element={
                                <SiteLayout>
                                    <Screen.ClinicSettings />
                                </SiteLayout>
                            }
                        />
                    </Route>
                    <Route path="admin-user">
                        <Route
                            path="list"
                            element={
                                <SiteLayout>
                                    <Screen.AdminUsersList />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path="new"
                            element={
                                <SiteLayout>
                                    <Screen.NewAdmin />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path="info/:id"
                            element={
                                <SiteLayout>
                                    <Screen.InfoAdmin />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path="edit/:id"
                            element={
                                <SiteLayout>
                                    <Screen.EditAdmin />
                                </SiteLayout>
                            }
                        />
                    </Route>
                    <Route path="app-user">
                        <Route
                            path=""
                            element={
                                <SiteLayout>
                                    <Screen.AppUsersList />
                                </SiteLayout>
                            }
                        />

                        <Route
                            path="edit/:id"
                            element={
                                <SiteLayout>
                                    <Screen.EditAppUser />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path=":id/summary"
                            element={
                                <SiteLayout>
                                    <Screen.UserSummary />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path=":id/insights"
                            element={
                                <SiteLayout>
                                    <Screen.UserInsights />
                                </SiteLayout>
                            }
                        />
                        <Route path=":id/progress">
                            <Route
                                path="detail"
                                element={
                                    <SiteLayout>
                                        <Screen.UserProgressDetail />
                                    </SiteLayout>
                                }
                            />
                            <Route
                                path="sleep/week/:weekNumber"
                                element={
                                    <SiteLayout>
                                        <Screen.UserProgressSleep />
                                    </SiteLayout>
                                }
                            />
                            <Route
                                path="report"
                                element={
                                    <SiteLayout>
                                        <Screen.UserProgressReport />
                                    </SiteLayout>
                                }
                            />
                            <Route
                                path="overview"
                                element={
                                    <SiteLayout>
                                        <Screen.UserProgressOverview />
                                    </SiteLayout>
                                }
                            />
                        </Route>
                        <Route path="info/:id">
                            <Route
                                path=""
                                element={
                                    <SiteLayout>
                                        <Screen.InfoUser />
                                    </SiteLayout>
                                }
                            />
                        </Route>
                        <Route path=":userId/food-summary">
                            <Route
                                path="daily/:dayId"
                                element={
                                    <SiteLayout>
                                        <Screen.DailySummaryPage />
                                    </SiteLayout>
                                }
                            />
                            <Route
                                path="weekly/:weekId"
                                element={
                                    <SiteLayout>
                                        <Screen.WeeklySummaryPage />
                                    </SiteLayout>
                                }
                            />
                        </Route>
                    </Route>
                    <Route path="UserAccess">
                        <Route
                            path=""
                            element={
                                <SiteLayout>
                                    <Screen.UserAccessList />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path="edit/:id"
                            element={
                                <SiteLayout>
                                    <Screen.EditRole />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path="new"
                            element={
                                <SiteLayout>
                                    <Screen.NewRole />
                                </SiteLayout>
                            }
                        />
                    </Route>
                    <Route path="Message">
                        <Route
                            path=""
                            element={
                                <SiteLayout>
                                    <Screen.TicketList />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path=":id"
                            element={
                                <SiteLayout>
                                    <Screen.TicketID />
                                </SiteLayout>
                            }
                        />
                    </Route>
                    <Route path="tickets">
                        <Route
                            path=""
                            element={
                                <SiteLayout>
                                    <Screen.TicketsList />
                                </SiteLayout>
                            }
                        />
                        <Route
                            path=":id"
                            element={
                                <SiteLayout>
                                    <Screen.TicketDetail />
                                </SiteLayout>
                            }
                        />
                    </Route>
                    <Route path="recipe">
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.RecipeList />
                                </SiteLayout>
                            }
                            path="list"
                        />
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.RecipeCreate />
                                </SiteLayout>
                            }
                            path="new"
                        />
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.RecipeEdit />
                                </SiteLayout>
                            }
                            path="edit/:id"
                        />
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.RecipeShow />
                                </SiteLayout>
                            }
                            path="info/:id"
                        />
                    </Route>
                    <Route
                        path="food-catalog"
                        element={
                            <SiteLayout>
                                <Screen.FoodCatalogPage />
                            </SiteLayout>
                        }
                    />
                    <Route path="peer-group">
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.PeerGroupList />
                                </SiteLayout>
                            }
                            path="list"
                        />
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.PeerGroupShow />
                                </SiteLayout>
                            }
                            path="info/:id"
                        />
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.PeerGroupEdit />
                                </SiteLayout>
                            }
                            path="edit/:id"
                        />
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.PeerGroupCreate />
                                </SiteLayout>
                            }
                            path="new"
                        />
                        <Route path=":id">
                            <Route path="post">
                                <Route
                                    element={
                                        <SiteLayout>
                                            <Screen.PeerGroupPostCreate />
                                        </SiteLayout>
                                    }
                                    path="new"
                                />
                                <Route
                                    element={
                                        <SiteLayout>
                                            <Screen.PostShow />
                                        </SiteLayout>
                                    }
                                    path="info/:postId"
                                />
                                <Route
                                    element={
                                        <SiteLayout>
                                            <Screen.PeerGroupPostEdit />
                                        </SiteLayout>
                                    }
                                    path="edit/:postId"
                                />
                            </Route>
                        </Route>
                    </Route>
                    <Route
                        path="goal-approvals"
                        element={
                            <SiteLayout>
                                <Screen.GoalApprovalsPage />
                            </SiteLayout>
                        }
                    />
                    <Route path="lesson">
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.LessonList />
                                </SiteLayout>
                            }
                            path="list"
                        />
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.LessonShow />
                                </SiteLayout>
                            }
                            path="info/:id"
                        />
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.LessonEdit />
                                </SiteLayout>
                            }
                            path="edit/:id"
                        />
                        <Route
                            element={
                                <SiteLayout>
                                    <Screen.LessonCreate />
                                </SiteLayout>
                            }
                            path="new"
                        />
                        <Route path=":id">
                            <Route path="slide">
                                <Route
                                    element={
                                        <SiteLayout>
                                            <Screen.LessonSlideCreate />
                                        </SiteLayout>
                                    }
                                    path="new"
                                />
                                <Route
                                    element={
                                        <SiteLayout>
                                            <Screen.LessonSlideShow />
                                        </SiteLayout>
                                    }
                                    path="info/:slideId"
                                />
                                <Route
                                    element={
                                        <SiteLayout>
                                            <Screen.LessonSlideEdit />
                                        </SiteLayout>
                                    }
                                    path="edit/:slideId"
                                />
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

const Auth = () => {
    const token = useAppSelector(selectUser);
    const location = useLocation();
    const clinicUser = isClinicUser(token);

    if (
        token === undefined ||
        token?.access_token === undefined ||
        token?.access_token === ""
    ) {
        return <Navigate to="/login" replace />;
    }

    if (
        clinicUser &&
        location.pathname !== "/clinic/patients" &&
        location.pathname !== "/clinic/patients/new" &&
        location.pathname !== "/clinic/settings" &&
        !location.pathname.startsWith("/clinic/patients/")
    ) {
        return <Navigate to="/clinic/patients" replace />;
    }

    return <Outlet />;
};

const HomeEntry = () => {
    const user = useAppSelector(selectUser);

    if (isClinicUser(user)) {
        return <Navigate to="/clinic/patients" replace />;
    }

    return <Navigate to="/app-user" replace />;
};

const ClinicOnly = () => {
    const user = useAppSelector(selectUser);

    if (!isClinicUser(user)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};
